import { createElement, memo } from '@max/max';
import Image from '@hfe/max-image';
import View from '@hfe/max-view';
import Sensor from '@max/mbc-sensor';
import Price from '@max/leez-price';
import Text from '@hfe/max-text';
import LinearGradient from '@hfe/max-linear-gradient';
import './index.scss';
import { CARD_MC, CARD_MV, POS_ICON } from '../../utils/constant';
import { formatDiscount, formatPrice, getLocString } from '../../utils/utils';
import { venusParams } from '../../utils/formatImage';
// import { navigateTo } from '@max/meituan-uni-navigate';
import navigateToPage from '../../utils/jump';
const MyComponent = (props) => {
    var _a;
    const { dealText, index, _LXReport, menuId, item, channelId } = props;
    const { mvReport, mcReportWithTag } = _LXReport;
    function handleBuy() {
        mcReportWithTag && mcReportWithTag(CARD_MC, {
            valLab: {
                deal_id: item === null || item === void 0 ? void 0 : item.dealId,
                instance_id: menuId,
                item_index: index,
                poi_id: item === null || item === void 0 ? void 0 : item.poiId
            }
        });
        navigateToPage(item === null || item === void 0 ? void 0 : item.dealJumpLink, item === null || item === void 0 ? void 0 : item.dealId, channelId);
    }
    return <Sensor 
    // once={true}
    onAppear={() => {
        mvReport && mvReport(CARD_MV, {
            valLab: {
                deal_id: item === null || item === void 0 ? void 0 : item.dealId,
                instance_id: menuId,
                item_index: index
            }
        });
    }}>
      <View className="double-card-container" onClick={handleBuy}>
        <View className="double-card-image-view">
          <Image className="double-card-image" source={{
        uri: venusParams(item === null || item === void 0 ? void 0 : item.frontImg, 342, 256)
    }}/>
          <LinearGradient className="double-card-image-shadow" start={{
        x: 0,
        y: 0
    }} end={{
        x: 0,
        y: 1
    }} colors={['rgba(0,0,0,0.00)', '#000000']}/>
          <View className="double-card-pos">
            <Image className="double-card-pos-icon" source={{
        uri: POS_ICON
    }}/>
            <Text className="double-card-pos-text">{getLocString(item === null || item === void 0 ? void 0 : item.dealLocateInfo)}</Text>
          </View>
        </View>
        <Text className="double-card-deal-title" numberOfLines={2}>{item === null || item === void 0 ? void 0 : item.dealName}</Text>
        <View className="double-card-tag-field">
          {!!(item === null || item === void 0 ? void 0 : item.discountRate) && (item === null || item === void 0 ? void 0 : item.discountRate) !== '0.0' && (item === null || item === void 0 ? void 0 : item.discountRate) !== '10.0' && <View className="double-card-discount-tag">
            <Text className="double-card-discount-text">{formatDiscount(item === null || item === void 0 ? void 0 : item.discountRate)}折</Text>
          </View>}
          {(item === null || item === void 0 ? void 0 : item.dealSaleTags) && ((_a = item === null || item === void 0 ? void 0 : item.dealSaleTags) === null || _a === void 0 ? void 0 : _a.map((tagItem) => {
        var _a;
        return (tagItem === null || tagItem === void 0 ? void 0 : tagItem.tagType) === 2 ? <View className="double-card-sale-tag" style={{
            backgroundColor: tagItem === null || tagItem === void 0 ? void 0 : tagItem.backgroundColor
        }}>
            <Text className="double-card-sale-text" style={{
            color: tagItem === null || tagItem === void 0 ? void 0 : tagItem.color
        }}>{tagItem === null || tagItem === void 0 ? void 0 : tagItem.title}</Text>
          </View> : <Image className="double-card-sale-tag-image" style={{
            width: (tagItem === null || tagItem === void 0 ? void 0 : tagItem.title) ? ((_a = tagItem === null || tagItem === void 0 ? void 0 : tagItem.title) === null || _a === void 0 ? void 0 : _a.length) * 15 : 60
        }} resizeMode="contain" source={{
            uri: tagItem === null || tagItem === void 0 ? void 0 : tagItem.icon
        }}/>;
    }))}
        </View>
        <View className="double-card-bottom-field">
          <View className="double-card-price-field">
            <View className="double-card-price">
            <Price type='l8' style={{
        fontSize: '42rpx',
        color: 'rgb(255, 75, 16)'
    }} content={formatPrice(item === null || item === void 0 ? void 0 : item.price)} priceStyle={{
        color: '#FF4B10'
    }} symbolStyle={{
        color: '#FF4B10'
    }}/>
              <Text className="double-card-price-start">起</Text>
            </View>
            {!!(item === null || item === void 0 ? void 0 : item.originalPrice) && (item === null || item === void 0 ? void 0 : item.price) !== (item === null || item === void 0 ? void 0 : item.originalPrice) && <Price className="double-card-origin-price" type='l6' crossed={true} content={formatPrice(item === null || item === void 0 ? void 0 : item.originalPrice)}/>}
          </View>
          <View>
            <LinearGradient className="double-card-btn" start={{
        x: 0,
        y: 0
    }} end={{
        x: 1,
        y: 1
    }} colors={['#FF7700', '#FF4B10']}>
              <Text className="double-card-btn-text">{dealText}</Text>
            </LinearGradient>
          </View>
        </View>
      </View>
    </Sensor>;
};
export default memo(MyComponent);
